<template>
  <NavBar class="PlainNavBar">
    <router-link
      v-if="superuser"
      class="d-inline-flex align-center mr-3"
      :to="{ name: 'Dashboard' }"
    >
      <i class="far fa-fw fa-gear icon" />
    </router-link>
  </NavBar>
</template>

<script>
import NavBar from '@/components/common/NavBar'

export default {
  name: 'PlainNavBar',
  components: {
    NavBar,
  },
  computed: {
    superuser() {
      return this.$auth.user && this.$auth.user['https://evmaps.nl/superuser']
    },
  },
}
</script>

<style lang="scss">
.PlainNavBar {
  .icon {
    color: white;
    font-size: 1.75rem;
    cursor: pointer;
  }
}

.ManualNavBar__Logout {
  color: white;
  cursor: pointer;

  &:hover {
    color: var(--cta);
  }
}
</style>
